import { useContext } from 'react';
import { ModalContext } from '@/contexts/ModalProvider.jsx';
import { useTranslations } from 'next-intl';
import { UserIsOfLegalAgeStore } from '@/store/userIsOfLegalAge.js';

export const useAgeVerificationModal = setIsAgeRestrictedProductsModalOpen => {
  const { openActionModal, close } = useContext(ModalContext);
  const t = useTranslations('full_page_cart');
  const a = useTranslations('common.asides');

  const openAgeVerificationModal = () => {
    openActionModal({
      closeOnOuterClick: false,
      hasCenteredText: true,
      title: a('age_verification.age_modal_title'),
      text: a('age_verification.age_modal_text'),
      actions: [
        {
          btnLabel: a('age_verification.yes'),
          onClick: () => {
            close();
            UserIsOfLegalAgeStore.update(true);
          },
        },
        {
          btnLabel: a('age_verification.no'),
          btnVariant: 'text',
          onClick: () => {
            close();
            UserIsOfLegalAgeStore.update(false);
            if (setIsAgeRestrictedProductsModalOpen) {
              setIsAgeRestrictedProductsModalOpen(true);
            }
          },
        },
      ],
      img: {
        url: '/assets/wave-grocery/DrinkingBeer.png',
        ariaLabel: t('common.header.service_modal.description'),
        size: 'medium',
      },
    });
  };

  return { openAgeVerificationModal };
};
